import { object, any } from 'prop-types';
import { get, size } from 'lodash';

const GetUnitPrice = ({ item, children }) => {
    const sellingPrice = get(item, 'sellingPrice', get(item, 'picking.sellingPrice', 0));
    const listPrice = get(item, 'listPrice', 0);
    const unitMultiplier = get(item, 'unitMultiplier', 1);
    const priceTags = size(get(item, 'priceTags', [])) > 0;
    const price = sellingPrice / unitMultiplier;

    return children({
        priceTags, // Arreglo cuyo size si es mayor a 1 significa que el item tiene oferta
        listPrice, // Precio oferta
        price // Precio
    });
};

GetUnitPrice.propTypes = {
    item: object,
    children: any
};

GetUnitPrice.defaultProps = {
    item: {},
    children: {}
};

export default GetUnitPrice;
